export const PROVIDER_PORTAL_DEFAULT_SORT = {
  sortedColumn: 'name',
  sortedColumnOrder: 'ascend'
}

export const PROVIDER_PORTAL_ENABLED = [
  { key: 'enabled_0', value: 1, title: 'Active' },
  { key: 'enabled_1', value: 0, title: 'Inactive' }
]

export const PROVIDER_PORTAL_ENABLED_V5 = [
  { key: 'enabled_0', value: 1, label: 'Active' },
  { key: 'enabled_1', value: 0, label: 'Inactive' }
]

export const PROVIDER_PORTAL_ACCESS_CONFIGURATION = [
  { key: 'PROVIDER', value: 1, label: 'Provider' },
  {
    key: 'PATIENT_LIST',
    value: 2,
    label: 'Provider with Limited Patient List'
  },
  { key: 'HOME_CARE', value: 3, label: 'HomeCare' },
  { key: 'PAYER', value: 4, label: 'Payer' }
]
